import React, { createContext, useMemo, useState } from 'react';
import { node } from 'prop-types';

import { PopUpStockAmend } from '@screens/StockBuySell/StockAmend';
import { PopUpStockWithdraw } from '@screens/StockBuySell/StockWithdraw';

export const OrderActionContext = createContext();

const OrderActionProvider = ({ children }) => {
  const [popup, setPopup] = useState({ open: '', data: null });

  const contextValue = useMemo(() => ({ popup, setPopup }), [popup, setPopup]);

  return (
    <OrderActionContext.Provider value={contextValue}>
      {children}
      <PopUpStockAmend
        show={popup.open === 'AMEND'}
        data={popup.data}
        onHide={() => setPopup({ open: '', data: null })}
      />
      <PopUpStockWithdraw
        show={popup.open === 'WITHDRAW'}
        data={popup.data}
        onHide={() => setPopup({ open: '', data: null })}
      />
    </OrderActionContext.Provider>
  );
};

OrderActionProvider.propTypes = {
  children: node,
};

OrderActionProvider.defaultProps = {
  children: null,
};

export default OrderActionProvider;
